import { SvgIcon, SvgIconProps } from '@mui/material';

export function MagnifyingGlassIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 500 500'
    >
      <g filter='url(#filter0_i_596_32)'>
        <rect
          width='500'
          height='500'
          rx='250'
          fill='#F0F5FF'
        />
        <g filter='url(#filter1_d_596_32)'>
          <path
            d='M290.288 214.858C290.288 265.037 249.258 305.716 198.644 305.716C148.03 305.716 107 265.037 107 214.858C107 164.678 148.03 124 198.644 124C249.258 124 290.288 164.678 290.288 214.858Z'
            fill='#3E8FFA'
          />
          <path
            d='M281.566 249.411L322.323 275.29L305.856 300.779L265.1 274.901L281.566 249.411Z'
            fill='#3E8FFA'
          />
          <path
            d='M305.314 281.997C310.55 273.891 321.4 271.513 329.547 276.686L392.248 316.498C400.395 321.671 402.755 332.436 397.518 340.543C392.281 348.649 381.432 351.027 373.285 345.854L310.584 306.042C302.436 300.868 300.077 290.103 305.314 281.997Z'
            fill='#1F477D'
          />
          <path
            d='M317.643 273.258C319.842 269.613 324.593 268.417 328.255 270.588C331.918 272.759 333.104 277.475 330.905 281.12L316.705 304.665C314.507 308.311 309.755 309.506 306.093 307.335C302.431 305.164 301.244 300.449 303.443 296.803L317.643 273.258Z'
            fill='#1F477D'
          />
        </g>
        <path
          d='M290.288 214.858C290.288 265.037 249.257 305.716 198.644 305.716C148.03 305.716 107 265.037 107 214.858C107 164.678 148.03 124 198.644 124C249.257 124 290.288 164.678 290.288 214.858Z'
          fill='#3E8FFA'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M198.644 295.716C243.816 295.716 280.288 259.433 280.288 214.858C280.288 170.282 243.816 134 198.644 134C153.472 134 117 170.282 117 214.858C117 259.433 153.472 295.716 198.644 295.716ZM198.644 305.716C249.257 305.716 290.288 265.037 290.288 214.858C290.288 164.678 249.257 124 198.644 124C148.03 124 107 164.678 107 214.858C107 265.037 148.03 305.716 198.644 305.716Z'
          fill='#3E8FFA'
        />
        <circle
          cx='197.907'
          cy='214.907'
          r='70.1208'
          fill='#F0F5FF'
          stroke='#F0F5FF'
          strokeWidth='6'
        />
        <rect
          width='48.2786'
          height='30.3458'
          transform='matrix(0.844199 0.53603 -0.54262 0.839979 281.566 249.411)'
          fill='#3E8FFA'
        />
        <rect
          x='1.20632'
          y='5.50403'
          width='101.221'
          height='26.9484'
          rx='13.4742'
          transform='matrix(0.844199 0.53603 -0.54262 0.839979 317.97 267.553)'
          fill='#1F477D'
          stroke='#1F477D'
          strokeWidth='8'
        />
        <rect
          width='15.4174'
          height='42.9129'
          rx='7.7087'
          transform='matrix(0.860212 0.509937 -0.516451 0.856317 321.625 266.657)'
          fill='#1F477D'
        />
        <path
          d='M317.307 273.994L303.379 296.819L297.244 288.973L307.854 270.632L317.307 273.994Z'
          fill='#3E8FFA'
        />
      </g>
      <defs>
        <filter
          id='filter0_i_596_32'
          x='0'
          y='0'
          width='509'
          height='520'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_596_32'
          />
        </filter>
        <filter
          id='filter1_d_596_32'
          x='105'
          y='124'
          width='307.305'
          height='241.59'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_596_32'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_596_32'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
